import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { ChannelRecordingFilters } from '../types';

export const useChannelRecordingFilters = createTableFiltersState<ChannelRecordingFilters>({
  tableKey: TableKeyEnum.CHANNEL_RECORDINGS,
});
